import { formatCurrency } from "../../../utils/formatters";

/** Display helpers for the pricing-trial page. Plain words, no model keys. */

export const STATUS_LABELS = {
  open: "Still open",
  won: "Won",
  lost: "Lost",
};

const TIER_LABELS = {
  retail: "Retail",
  contractor: "Contractor",
  dealer: "Dealer",
  distributor: "Distributor",
};

const FINISH_LABELS = {
  without_paint: "No paint",
  with_paint: "Painted",
};

const MODEL_LABELS = {
  rafter_tail_linked_v1: "Trial model v1",
};

export function tierLabel(tier) {
  if (!tier) return "Not set";
  return TIER_LABELS[tier] || tier;
}

export function finishLabel(options) {
  if (!Array.isArray(options) || options.length === 0) return "Not priced";
  return options.map((option) => FINISH_LABELS[option] || option).join(", ");
}

export function modelLabel(key) {
  return MODEL_LABELS[key] || key || "";
}

/** "$1,651.42", or an em dash when the amount was never recorded. */
export function money(value) {
  if (value === null || value === undefined || value === "") return "—";
  const amount = Number(value);
  return Number.isFinite(amount) ? formatCurrency(amount) : "—";
}

export function hours(value) {
  if (value === null || value === undefined || value === "") return null;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return null;
  return `${amount.toLocaleString("en-US", { maximumFractionDigits: 2 })} hrs`;
}

/** YYYY-MM-DD read as a calendar day (never shifted by the time zone). */
export function shortDate(iso) {
  if (!iso || typeof iso !== "string") return "—";
  const [year, month, day] = iso.split("-").map(Number);
  if (!year || !month || !day) return iso;
  return new Date(year, month - 1, day).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function winRate(rate) {
  if (rate === null || rate === undefined) return "—";
  const value = Number(rate);
  return Number.isFinite(value) ? `${Math.round(value * 100)}%` : "—";
}
